import React from "react";

/**
 * Ikon admin dashboard memakai **Remix Icon** (webfont, di-import di index.js).
 * API `Icon.X` dipertahankan agar call-site tak berubah. `size` → font-size (px).
 */
function make(cls) {
  return function RemixIcon({ size = 20, className = "", style, ...p }) {
    return (
      <i
        className={`${cls} ${className}`}
        style={{ fontSize: size, lineHeight: 1, ...style }}
        aria-hidden="true"
        {...p}
      />
    );
  };
}

export const Icon = {
  // Navigasi
  Home: make("ri-home-5-line"),
  Attendance: make("ri-calendar-check-line"),
  Leave: make("ri-plane-line"),
  Users: make("ri-group-line"),
  Clock: make("ri-time-line"),
  Key: make("ri-key-2-line"),
  Shield: make("ri-shield-check-line"),
  Doc: make("ri-file-list-3-line"),
  Alert: make("ri-error-warning-line"),
  Logout: make("ri-logout-box-r-line"),
  // Aksi / kontrol
  Refresh: make("ri-refresh-line"),
  Search: make("ri-search-line"),
  Calendar: make("ri-calendar-line"),
  ChevronLeft: make("ri-arrow-left-s-line"),
  ChevronRight: make("ri-arrow-right-s-line"),
  Filter: make("ri-filter-3-line"),
  Dots: make("ri-more-fill"),
  Menu: make("ri-menu-line"),
  Close: make("ri-close-line"),
  Bell: make("ri-notification-3-line"),
  ArrowRight: make("ri-arrow-right-line"),
  ArrowDown: make("ri-arrow-down-line"),
  ArrowUp: make("ri-arrow-up-line"),
  Send: make("ri-send-plane-fill"),
  // Detail absensi
  CheckIn: make("ri-login-box-line"),
  CheckOut: make("ri-logout-box-line"),
  Building: make("ri-building-line"),
  Briefcase: make("ri-briefcase-4-line"),
  Mode: make("ri-computer-line"),
  MapPin: make("ri-map-pin-line"),
  Timer: make("ri-timer-line"),
  User: make("ri-user-3-line"),
  // Maintenance / pantau server
  Tools: make("ri-tools-line"),
  Server: make("ri-server-line"),
  Trash: make("ri-delete-bin-6-line"),
  File: make("ri-file-text-line"),
  Support: make("ri-customer-service-2-line"),
  Inbox: make("ri-inbox-line"),
  Attachment: make("ri-attachment-2"),
  Check: make("ri-check-line"),
};

export default Icon;
